module.exports = new __parcel__URL__("course_2.e3e5342e.jpg").toString();